import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ResendCode } from "@faire/retailer-visitor-shared/components/AppSignIn/components/__internal__/ResendCode";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { MFASentWaitingView } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EmailSentWaitingView";
import { logErrorSignIn } from "@faire/retailer-visitor-shared/components/AppSignIn/components/logErrorSignIn";
import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { isNumericOrBlank, isNumericOrBlankCode, VALID_CODE_LENGTH } from "@faire/retailer-visitor-shared/components/AppSignIn/components/VerificationInputUtils";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSignInEventTracker } from "@faire/retailer-visitor-shared/components/AppSignIn/useSignInEventTracker";
import { VerificationInput } from "@faire/retailer-visitor-shared/components/VerificationInput/VerificationInput";
import { useSettingMFAExperienceXP, useSettingAllowMFASkipPassword } from "@faire/retailer-visitor-shared/settings/useSettingSignInImprovements";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Checkbox } from "@faire/web--source/slate/Checkbox";
import { PasswordInput } from "@faire/web--source/slate/Input/PasswordInput/PasswordInput";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { trackRetailerPortalLoginModalLoggedInWithSecondFactor } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalLoggedInWithSecondFactor";
import { trackRetailerPortalLoginModalLoginWithSecondFactor } from "@faire/web-api--source/events/retailerPortal/actionUnknown/loginModalLoginWithSecondFactor";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import React, { useState, useRef } from "react";
import styled from "styled-components";
export var EnterMFAView = function(props) {
    var onComplete = props.onComplete, email = props.email, mfaTitle = props.mfaTitle, mfaDescription = props.mfaDescription;
    var settingMFAExperienceXP = useSettingMFAExperienceXP();
    if (email && settingMFAExperienceXP) {
        return /*#__PURE__*/ _jsx(MFASentWaitingView, {
            onComplete: onComplete,
            email: email,
            mfaTitle: mfaTitle,
            mfaDescription: mfaDescription
        });
    }
    return /*#__PURE__*/ _jsx(EnterMFAViewBase, _object_spread({}, props));
};
var EnterMFAViewBase = function(param) {
    var email = param.email, password = param.password, userToken = param.userToken, mfaTitle = param.mfaTitle, mfaDescription = param.mfaDescription, mfaMethod = param.mfaMethod, onComplete = param.onComplete, onLogin = param.onLogin, isMFAFromEmail = param.isMFAFromEmail;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var trackFieldValue = useSignInEventTracker("ENTER_MFA").trackFieldValue;
    var _useState = _sliced_to_array(useState(false), 2), isLoadingAutoLogin = _useState[0], setIsLoadingAutoLogin = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), showResend = _useState1[0], setShowResend = _useState1[1];
    var code = useRef("");
    var _useState2 = _sliced_to_array(useState(), 2), error = _useState2[0], setError = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), passwordState = _useState3[0], setPasswordState = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), hasCodeInputError = _useState4[0], setHasCodeInputError = _useState4[1];
    var _useState5 = _sliced_to_array(useState(), 2), verificationInputErrorMessage = _useState5[0], setVerificationInputErrorMessage = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), clearVerificationInput = _useState6[0], setClearVerificationInput = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), showPasswordInput = _useState7[0], setShowPasswordInput = _useState7[1];
    var _useState8 = _sliced_to_array(useState(true), 2), suppressFutureMfa = _useState8[0], setSuppressFutureMfa = _useState8[1];
    var _useSSOStore = useSSOStore(), isActive = _useSSOStore.isActive, ssoToken = _useSSOStore.ssoToken;
    var allowMFASkipPassword = useSettingAllowMFASkipPassword();
    var skipPasswordInput = isMFAFromEmail || allowMFASkipPassword;
    var setCode = function(codeValue) {
        code.current = codeValue;
    };
    var handleShouldSuppressFutureMfaChange = function() {
        return setSuppressFutureMfa(!suppressFutureMfa);
    };
    var handleVerificationCodeInputChange = function(codeValue, slotValue) {
        setCode(codeValue);
        setHasCodeInputError(false);
        setError(undefined);
        trackFieldValue("mfaCode", codeValue);
        if (!isNumericOrBlankCode(slotValue)) {
            setVerificationInputErrorMessage(strictLocalize({
                id: "Wy3Kfu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Enter numbers only."
                    }
                ]
            }));
        } else if (isNumericOrBlankCode(code.current)) {
            setVerificationInputErrorMessage(undefined);
            var isValidPassword = !showPasswordInput || showPasswordInput && passwordState;
            if (isValidCode() && isValidPassword) {
                onContinue();
            }
        }
    };
    var handlePasswordChange = function(event) {
        setError(undefined);
        setPasswordState(event.currentTarget.value);
        trackFieldValue("password", "");
    };
    var onResend = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var mfa_method, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        mfa_method = mfaMethod !== null && mfaMethod !== void 0 ? mfaMethod : MfaMethod.EMAIL_ADDRESS; // Default resends to email address
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!isActive) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            login(ILoginRequest.build({
                                sso_token: ssoToken,
                                resend: true,
                                password: passwordState ? passwordState : password,
                                enable_mfa_method_selection: true,
                                mfa_method: mfa_method
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            login(ILoginRequest.build({
                                email_address: email,
                                user_token: !email ? userToken : undefined,
                                resend: true,
                                password: passwordState ? passwordState : password,
                                enable_mfa_method_selection: true,
                                mfa_method: mfa_method
                            }))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        setShowResend(false);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        logErrorSignIn("ENTER_MFA", convertErrorToLoginError(e, strictLocalize).message);
                        setError(convertErrorToLoginError(e, strictLocalize));
                        if (!skipPasswordInput) {
                            setShowPasswordInput(true);
                        }
                        setHasCodeInputError(false);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResend() {
            return _ref.apply(this, arguments);
        };
    }();
    var getUser = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var request, user;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        request = isActive ? ILoginRequest.build({
                            mfa_code: code.current,
                            sso_token: ssoToken,
                            password: passwordState ? passwordState : password,
                            enable_mfa_method_selection: true,
                            should_suppress_future_mfa: suppressFutureMfa
                        }) : ILoginRequest.build({
                            mfa_code: code.current,
                            email_address: email,
                            user_token: !email ? userToken : undefined,
                            password: passwordState ? passwordState : password,
                            enable_mfa_method_selection: true,
                            should_suppress_future_mfa: suppressFutureMfa
                        });
                        return [
                            4,
                            login(request)
                        ];
                    case 1:
                        user = _state.sent().user;
                        return [
                            2,
                            user
                        ];
                }
            });
        });
        return function getUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var user, nextView, e, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackRetailerPortalLoginModalLoginWithSecondFactor();
                        setError(undefined);
                        setIsLoadingAutoLogin(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getUser()
                        ];
                    case 2:
                        user = _state.sent();
                        if (!user) {
                            setError(new LoginError(strictLocalize({
                                id: "6Qgt73",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Invalid credentials"
                                    }
                                ]
                            })));
                            return [
                                2
                            ];
                        }
                        nextView = user.missing_password && // Skip create password if MFA and SSO are used
                        !isActive ? View.CREATE_PASSWORD : View.LOADING;
                        if (nextView === View.LOADING) {
                            trackRetailerPortalLoginModalLoggedInWithSecondFactor();
                            onLogin(user);
                        }
                        onComplete({
                            nextView: nextView,
                            loggedInUser: user
                        });
                        setClearVerificationInput(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        error = convertErrorToLoginError(e, strictLocalize);
                        logErrorSignIn("ENTER_MFA", error.message);
                        setPasswordState("");
                        setCode("");
                        if (showPasswordInput) {
                            setError(convertErrorToLoginError(e, strictLocalize, {
                                isMFALoginAttempt: true
                            }));
                        } else if (error.httpStatusCode === 400 && skipPasswordInput) {
                            setError(new LoginError(strictLocalize({
                                id: "vaoEgc",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Invalid code"
                                    }
                                ]
                            })));
                        }
                        if (!skipPasswordInput) {
                            setShowPasswordInput(true);
                        }
                        setHasCodeInputError(false);
                        setIsLoadingAutoLogin(false);
                        setClearVerificationInput(true);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var isValidCode = function() {
        return code.current.length === VALID_CODE_LENGTH && !verificationInputErrorMessage && !hasCodeInputError;
    };
    var shouldShowReEnterPasswordTitle = error && !skipPasswordInput || showPasswordInput;
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                align: "left",
                children: shouldShowReEnterPasswordTitle ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "OVluHq",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Re-enter your password and code"
                        }
                    ]
                }) : mfaTitle
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                align: "left",
                children: mfaDescription
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            showPasswordInput ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(PasswordInput, {
                        label: strictLocalize({
                            id: "ZL7EZd",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Password"
                                }
                            ]
                        }),
                        value: passwordState,
                        onChange: handlePasswordChange,
                        "data-test-id": "password"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(VerificationInput, {
                label: showPasswordInput ? strictLocalize({
                    id: "HZ/veK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "6-digit code"
                        }
                    ]
                }) : undefined,
                validateFn: isNumericOrBlank,
                onChange: handleVerificationCodeInputChange,
                errorMessage: verificationInputErrorMessage !== null && verificationInputErrorMessage !== void 0 ? verificationInputErrorMessage : error === null || error === void 0 ? void 0 : error.message,
                isValidInput: isValidCode(),
                errorAll: hasCodeInputError,
                value: code.current,
                disableAutoFocus: showPasswordInput,
                ariaLabel: strictLocalize({
                    id: "wR3iLI",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter Verification Code"
                        }
                    ]
                }),
                clearInput: clearVerificationInput
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(ResendCode, {
                onResend: onResend,
                showResend: showResend,
                mfaMethod: mfaMethod
            }),
            /*#__PURE__*/ _jsx(UserDeviceMfaSuppressionCheckbox, {
                checked: suppressFutureMfa,
                onChange: handleShouldSuppressFutureMfaChange,
                label: strictLocalize({
                    id: "+vXkNO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Don't ask again for 30 days"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(ContinueToNextViewButton, {
                onClick: onContinue,
                isLoading: isLoadingAutoLogin,
                disabled: !isValidCode()
            })
        ]
    });
};
var UserDeviceMfaSuppressionCheckbox = styled(Checkbox).withConfig({
    componentId: "sc-a0911119-0"
})([
    "margin-top:",
    ";"
], getSpacing("2x"));
